"use client"

import { useState, useEffect } from "react"
import { useAuth } from "../../../contexts/AuthContext"

const MagnifyingGlassIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
    />
  </svg>
)

const FunnelIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
    />
  </svg>
)

const EyeIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
    />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </svg>
)

const TrashIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
    />
  </svg>
)

const XMarkIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
  </svg>
)

const ChevronLeftIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
  </svg>
)

const ChevronRightIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
  </svg>
)

const VideoIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z"
    />
  </svg>
)

const ImageIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
    />
  </svg>
)

const DocumentIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    />
  </svg>
)

const Templates = () => {
  const { fetchTemplates, syncTemplates, deleteTemplate, getAllUsers, user } = useAuth()
  const [templates, setTemplates] = useState([])
  const [loading, setLoading] = useState(true)
  const [syncing, setSyncing] = useState(false)
  const [darkMode, setDarkMode] = useState(false)
  const [users, setUsers] = useState([])
  const [selectedUserId, setSelectedUserId] = useState("")

  const [searchTerm, setSearchTerm] = useState("")
  const [filterCategory, setFilterCategory] = useState("all")
  const [filterStatus, setFilterStatus] = useState("all")
  const [currentPage, setCurrentPage] = useState(1)
  const [templatesPerPage, setTemplatesPerPage] = useState(10)
  const [selectedTemplate, setSelectedTemplate] = useState(null)
  const [showTemplateModal, setShowTemplateModal] = useState(false)

  useEffect(() => {
    const init = async () => {
      if (["superadmin", "admin", "reseller", "company"].includes(user?.role)) {
        await loadUsers()
      }
      await loadTemplates(selectedUserId)
    }
    init()
  }, [user, selectedUserId])

  const loadUsers = async () => {
    try {
      const response = await getAllUsers()
      if (response.success) {
        setUsers(response.users)
      }
    } catch (error) {
      console.error("Error loading user list:", error)
    }
  }

  const loadTemplates = async (userId = "") => {
    setLoading(true)
    try {
      const templatesData = await fetchTemplates(userId)
      setTemplates(templatesData)
    } catch (error) {
      console.error("Error loading templates:", error)
    } finally {
      setLoading(false)
    }
  }

  const toggleDarkMode = () => {
    const newDarkMode = !darkMode
    setDarkMode(newDarkMode)
    if (newDarkMode) {
      document.documentElement.classList.add("dark")
    } else {
      document.documentElement.classList.remove("dark")
    }
  }

  const handleSyncTemplates = async () => {
    setSyncing(true)
    try {
      const result = await syncTemplates(selectedUserId)
      if (result.success) {
        await loadTemplates(selectedUserId)
      }
    } catch (error) {
      console.error("Error syncing templates:", error)
    } finally {
      setSyncing(false)
    }
  }

  const handleDeleteTemplate = async (templateId) => {
    if (!window.confirm("Are you sure you want to delete this template?")) return

    try {
      const result = await deleteTemplate(templateId)
      if (result.success) {
        setTemplates(templates.filter((t) => t.templateId !== templateId))
      }
    } catch (error) {
      console.error("Error deleting template:", error)
    }
  }

  const getTemplateStats = () => {
    const total = templates.length
    const approved = templates.filter((t) => t.status === "APPROVED").length
    const rejected = templates.filter((t) => t.status === "REJECTED").length
    const pending = templates.filter((t) => t.status === "PENDING").length
    const utility = templates.filter((t) => t.category === "UTILITY").length
    const marketing = templates.filter((t) => t.category === "MARKETING").length
    const authentication = templates.filter((t) => t.category === "AUTHENTICATION").length

    return { total, approved, rejected, pending, utility, marketing, authentication }
  }

  const getFilteredTemplates = () => {
    let filtered = templates

    // Search filter
    if (searchTerm) {
      filtered = filtered.filter(
        (template) =>
          template.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          template.templateId.toLowerCase().includes(searchTerm.toLowerCase()) ||
          template.language.toLowerCase().includes(searchTerm.toLowerCase()),
      )
    }

    // Category filter
    if (filterCategory !== "all") {
      filtered = filtered.filter((template) => template.category === filterCategory)
    }

    // Status filter
    if (filterStatus !== "all") {
      filtered = filtered.filter((template) => template.status === filterStatus)
    }

    return filtered
  }

  const getPaginatedTemplates = () => {
    const filtered = getFilteredTemplates()
    const startIndex = (currentPage - 1) * templatesPerPage
    const endIndex = startIndex + templatesPerPage
    return filtered.slice(startIndex, endIndex)
  }

  const getTotalPages = () => {
    const filtered = getFilteredTemplates()
    return Math.ceil(filtered.length / templatesPerPage)
  }

  const getTemplateBodyText = (template) => {
    if (!template.components || !Array.isArray(template.components)) return "No body text"

    const bodyComponent = template.components.find((c) => c.type === "BODY")
    if (!bodyComponent) return "No body text"

    // Handle different body text formats
    if (bodyComponent.text) {
      return bodyComponent.text
    } else if (bodyComponent.example && bodyComponent.example.body_text) {
      return bodyComponent.example.body_text[0]?.text || "No body text"
    } else if (bodyComponent.parameters) {
      // If there are parameters, show a generic message
      return "Template with dynamic content"
    }

    return "No body text"
  }

  const handleViewTemplate = (template) => {
    setSelectedTemplate(template)
    setShowTemplateModal(true)
  }

  const getStatusBadge = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
      case "pending":
        return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200"
      case "rejected":
        return "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
      default:
        return "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200"
    }
  }

  const getCategoryBadge = (category) => {
    switch (category?.toLowerCase()) {
      case "utility":
        return "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200"
      case "marketing":
        return "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200"
      case "authentication":
        return "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200"
      default:
        return "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200"
    }
  }

  const getMediaIcon = (component) => {
    if (component.type === "HEADER") {
      if (component.format === "VIDEO") {
        return <VideoIcon className="w-6 h-6 text-gray-400" />
      } else if (component.format === "IMAGE") {
        return <ImageIcon className="w-6 h-6 text-gray-400" />
      } else if (component.format === "DOCUMENT") {
        return <DocumentIcon className="w-6 h-6 text-gray-400" />
      }
    }
    return <DocumentIcon className="w-6 h-6 text-gray-400" />
  }

  const getMediaText = (component) => {
    if (component.type === "HEADER") {
      if (component.format === "VIDEO") {
        return "📹 Video will appear here"
      } else if (component.format === "IMAGE") {
        return "📷 Image will appear here"
      } else if (component.format === "DOCUMENT") {
        return "📄 Document will appear here"
      }
    }
    return "📄 Media will appear here"
  }

  const stats = getTemplateStats()
  const paginatedTemplates = getPaginatedTemplates()
  const totalPages = getTotalPages()

  const getPaginationNumbers = () => {
    const totalPages = getTotalPages()
    const current = currentPage
    const delta = 2 // Number of pages to show on each side of current page

    if (totalPages <= 7) {
      // If total pages is 7 or less, show all pages
      return Array.from({ length: totalPages }, (_, i) => i + 1)
    }

    const range = []
    const rangeWithDots = []

    // Always include first page
    range.push(1)

    // Calculate start and end of middle range
    const start = Math.max(2, current - delta)
    const end = Math.min(totalPages - 1, current + delta)

    // Add ellipsis after first page if needed
    if (start > 2) {
      rangeWithDots.push(1, "...")
    } else {
      rangeWithDots.push(1)
    }

    // Add middle range
    for (let i = start; i <= end; i++) {
      if (i !== 1 && i !== totalPages) {
        rangeWithDots.push(i)
      }
    }

    // Add ellipsis before last page if needed
    if (end < totalPages - 1) {
      rangeWithDots.push("...", totalPages)
    } else if (totalPages > 1) {
      rangeWithDots.push(totalPages)
    }

    // Remove duplicates and return
    return [...new Set(rangeWithDots)]
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading templates...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 bg-gradient-to-br from-green-50 to-yellow-50 dark:from-gray-900 dark:to-gray-800">
      <div className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="py-6">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
              <div>
                <h1 className="text-3xl lg:text-4xl font-bold bg-gradient-to-r from-green-700 to-yellow-600 bg-clip-text text-transparent mb-2">
                  Templates
                </h1>
                <p className="text-gray-600 dark:text-gray-400 text-lg">Manage your WhatsApp message templates</p>
              </div>
              <div className="mt-4 lg:mt-0 flex items-center space-x-4">
                <button
                  onClick={handleSyncTemplates}
                  disabled={syncing}
                  className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-green-600 to-yellow-600 text-white font-semibold rounded-xl hover:from-green-700 hover:to-yellow-700 disabled:opacity-50 transition-all duration-200"
                >
                  {syncing ? "Syncing..." : "Sync Templates"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4 mb-8">
          <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700">
            <div className="text-2xl font-bold text-gray-900 dark:text-white">{stats.total}</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Total Templates</div>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700">
            <div className="text-2xl font-bold text-green-600">{stats.approved}</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Approved</div>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700">
            <div className="text-2xl font-bold text-red-600">{stats.rejected}</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Rejected</div>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700">
            <div className="text-2xl font-bold text-yellow-600">{stats.pending}</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Pending</div>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700">
            <div className="text-2xl font-bold text-blue-600">{stats.utility}</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Utility</div>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700">
            <div className="text-2xl font-bold text-purple-600">{stats.marketing}</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Marketing</div>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700">
            <div className="text-2xl font-bold text-orange-600">{stats.authentication}</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Authentication</div>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 mb-6">
          <div className="flex flex-col lg:flex-row gap-4">
            {/* Search */}
            <div className="relative flex-1 max-w-md">
              <MagnifyingGlassIcon className="w-5 h-5 absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search templates..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value)
                  setCurrentPage(1)
                }}
                className="pl-12 pr-4 py-2 w-full border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
              />
            </div>

            {/* Category Filter */}
            <div className="relative">
              <FunnelIcon className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <select
                value={filterCategory}
                onChange={(e) => {
                  setFilterCategory(e.target.value)
                  setCurrentPage(1)
                }}
                className="pl-10 pr-8 py-2 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
              >
                <option value="all">All Categories</option>
                <option value="UTILITY">Utility</option>
                <option value="MARKETING">Marketing</option>
                <option value="AUTHENTICATION">Authentication</option>
              </select>
            </div>

            {/* Status Filter */}
            <div className="relative">
              <select
                value={filterStatus}
                onChange={(e) => {
                  setFilterStatus(e.target.value)
                  setCurrentPage(1)
                }}
                className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
              >
                <option value="all">All Status</option>
                <option value="APPROVED">Approved</option>
                <option value="PENDING">Pending</option>
                <option value="REJECTED">Rejected</option>
              </select>
            </div>

            {/* User Filter for admin/superadmin/reseller */}
            {(["superadmin", "admin", "reseller", "company"].includes(user?.role)) && (
              <div className="relative">
                <select
                  value={selectedUserId}
                  onChange={(e) => {
                    setSelectedUserId(e.target.value)
                    setCurrentPage(1)
                  }}
                  className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
                >
                  <option value="">All Users</option>
                  {users.map((u) => (
                    <option key={u.id || u._id} value={u.id || u._id}>
                      {u.name || u.email || u.username || u._id}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Per-page Selector */}
            <div className="relative">
              <select
                value={templatesPerPage}
                onChange={(e) => {
                  setTemplatesPerPage(Number(e.target.value))
                  setCurrentPage(1)
                }}
                className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
              >
                <option value={10}>10 per page</option>
                <option value={20}>20 per page</option>
                <option value={50}>50 per page</option>
                <option value={100}>100 per page</option>
              </select>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
          {paginatedTemplates.length === 0 ? (
            <div className="py-12 text-center">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">No Templates Found</h3>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                {templates.length === 0
                  ? "You do not have any templates yet. Sync your templates from WhatsApp to get started."
                  : "No templates match your current filters. Try adjusting your search or filter criteria."}
              </p>
              {templates.length === 0 && (
                <button
                  onClick={handleSyncTemplates}
                  disabled={syncing}
                  className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-green-600 to-yellow-600 text-white font-semibold rounded-xl hover:from-green-700 hover:to-yellow-700 disabled:opacity-50 transition-all duration-200"
                >
                  {syncing ? "Syncing..." : "Sync Templates"}
                </button>
              )}
            </div>
          ) : (
            <>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                  <thead className="bg-gray-50 dark:bg-gray-700">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        #
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        Template Name
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        Category
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        Message
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                    {paginatedTemplates.map((template, index) => (
                      <tr
                        key={template.templateId}
                        className="hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-200"
                      >
                        {/* Serial Number */}
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-500 dark:text-gray-400">
                          #{(currentPage - 1) * templatesPerPage + index + 1}
                        </td>

                        {/* Template Name with Language and Status */}
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex flex-col">
                            <div className="text-sm font-medium text-gray-900 dark:text-white">{template.name}</div>
                            <div className="flex items-center space-x-2 mt-1">
                              <span className="text-xs text-gray-500 dark:text-gray-400">({template.language})</span>
                              <span
                                className={`px-2 py-1 rounded-full text-xs font-semibold ${getStatusBadge(template.status)}`}
                              >
                                {template.status}
                              </span>
                            </div>
                          </div>
                        </td>

                        {/* Category */}
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span
                            className={`px-2 py-1 rounded-full text-xs font-semibold ${getCategoryBadge(template.category)}`}
                          >
                            {template.category}
                          </span>
                        </td>

                        {/* Message Preview */}
                        <td className="px-6 py-4">
                          <div className="text-sm text-gray-600 dark:text-gray-400 max-w-xs">
                            <p className="line-clamp-2 break-words">{getTemplateBodyText(template)}</p>
                          </div>
                        </td>

                        {/* Actions */}
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                          <div className="flex items-center space-x-2">
                            <button
                              onClick={() => handleViewTemplate(template)}
                              className="p-2 text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-lg transition-colors duration-200"
                              title="View Template"
                            >
                              <EyeIcon className="w-4 h-4" />
                            </button>
                            <button
                              onClick={() => handleDeleteTemplate(template.templateId)}
                              className="p-2 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors duration-200"
                              title="Delete Template"
                            >
                              <TrashIcon className="w-4 h-4" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Enhanced Pagination */}
              {totalPages > 1 && (
                <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700">
                  <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                    <div className="text-sm text-gray-600 dark:text-gray-400">
                      Showing {(currentPage - 1) * templatesPerPage + 1} to{" "}
                      {Math.min(currentPage * templatesPerPage, getFilteredTemplates().length)} of{" "}
                      {getFilteredTemplates().length} templates
                    </div>

                    <div className="flex items-center space-x-1">
                      {/* Previous Button */}
                      <button
                        onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                        disabled={currentPage === 1}
                        className="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                      >
                        <ChevronLeftIcon className="w-5 h-5" />
                      </button>

                      {/* Page Numbers */}
                      {getPaginationNumbers().map((pageNum, index) => (
                        <div key={index}>
                          {pageNum === "..." ? (
                            <span className="px-3 py-2 text-gray-500 dark:text-gray-400">...</span>
                          ) : (
                            <button
                              onClick={() => setCurrentPage(pageNum)}
                              className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 ${
                                currentPage === pageNum
                                  ? "bg-green-600 text-white"
                                  : "text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-white"
                              }`}
                            >
                              {pageNum}
                            </button>
                          )}
                        </div>
                      ))}

                      {/* Next Button */}
                      <button
                        onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                        disabled={currentPage === totalPages}
                        className="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                      >
                        <ChevronRightIcon className="w-5 h-5" />
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {showTemplateModal && selectedTemplate && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white">Template Preview</h3>
              <button
                onClick={() => setShowTemplateModal(false)}
                className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors duration-200"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Left side - Template Information */}
                <div>
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-4">Template Information</h4>
                  <div className="space-y-3 text-sm">
                    <div className="flex justify-between">
                      <span className="font-medium text-gray-600 dark:text-gray-400">Name:</span>
                      <span className="text-gray-900 dark:text-white">{selectedTemplate.name}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-medium text-gray-600 dark:text-gray-400">ID:</span>
                      <span className="text-gray-900 dark:text-white font-mono text-xs">
                        {selectedTemplate.templateId}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-medium text-gray-600 dark:text-gray-400">Language:</span>
                      <span className="text-gray-900 dark:text-white">{selectedTemplate.language}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="font-medium text-gray-600 dark:text-gray-400">Status:</span>
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-semibold ${getStatusBadge(selectedTemplate.status)}`}
                      >
                        {selectedTemplate.status}
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="font-medium text-gray-600 dark:text-gray-400">Category:</span>
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-semibold ${getCategoryBadge(selectedTemplate.category)}`}
                      >
                        {selectedTemplate.category}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-medium text-gray-600 dark:text-gray-400">Usage Count:</span>
                      <span className="text-gray-900 dark:text-white">{selectedTemplate.usageCount || 0}</span>
                    </div>
                  </div>
                </div>

                {/* Right side - WhatsApp Preview */}
                <div>
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-4">WhatsApp Preview</h4>
                  <div className="bg-gradient-to-b from-green-100 to-green-50 dark:from-green-900 dark:to-green-800 rounded-2xl p-4 max-w-sm mx-auto">
                    {/* Phone mockup header */}
                    <div className="bg-green-600 text-white px-4 py-2 rounded-t-xl flex items-center space-x-3">
                      <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                        <span className="text-xs font-bold">B</span>
                      </div>
                      <div>
                        <div className="text-sm font-medium">Business</div>
                        <div className="text-xs opacity-75">Online</div>
                      </div>
                    </div>

                    {/* Message bubble */}
                    <div className="bg-white dark:bg-gray-100 rounded-b-xl rounded-tr-xl p-4 shadow-sm">
                      {selectedTemplate.components && selectedTemplate.components.length > 0 ? (
                        <div className="space-y-3">
                          {selectedTemplate.components.map((component, index) => (
                            <div key={index}>
                              {component.type === "HEADER" &&
                                (component.format === "IMAGE" ||
                                  component.format === "VIDEO" ||
                                  component.format === "DOCUMENT") && (
                                  <div className="bg-gray-200 dark:bg-gray-300 rounded-lg p-8 text-center text-gray-500 text-sm mb-3 flex flex-col items-center space-y-2">
                                    {getMediaIcon(component)}
                                    <span>{getMediaText(component)}</span>
                                  </div>
                                )}

                              {component.type === "BODY" && (
                                <div className="text-gray-800 text-sm leading-relaxed">
                                  {component.text || getTemplateBodyText(selectedTemplate)}
                                </div>
                              )}

                              {component.type === "FOOTER" && component.text && (
                                <div className="text-gray-500 text-xs mt-2">{component.text}</div>
                              )}

                              {component.buttons && component.buttons.length > 0 && (
                                <div className="space-y-2 mt-3">
                                  {component.buttons.map((button, btnIndex) => (
                                    <div
                                      key={btnIndex}
                                      className="w-full py-2 px-4 border border-green-600 text-green-600 rounded-lg text-sm font-medium bg-white hover:bg-green-50 transition-colors flex items-center justify-center space-x-2"
                                    >
                                      {button.type === "PHONE_NUMBER" && <span>📞</span>}
                                      {button.type === "URL" && <span>🔗</span>}
                                      {button.type === "QUICK_REPLY" && <span>💬</span>}
                                      <span>{button.text}</span>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="text-gray-800 text-sm">{getTemplateBodyText(selectedTemplate)}</div>
                      )}

                      {/* Message timestamp */}
                      <div className="flex justify-end items-center mt-3 space-x-1">
                        <span className="text-xs text-gray-500">10:51 AM</span>
                        <span className="text-green-600 text-xs">✓✓</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-8">
                <h4 className="font-semibold text-gray-900 dark:text-white mb-4">Template Components</h4>
                {selectedTemplate.components && selectedTemplate.components.length > 0 ? (
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800 rounded-lg">
                      <thead className="bg-gray-50 dark:bg-gray-700">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Component Type
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Media/Header
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Content
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Buttons/Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                        {selectedTemplate.components.map((component, index) => (
                          <tr key={index} className="hover:bg-gray-50 dark:hover:bg-gray-700">
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="flex items-center">
                                <span className="font-medium text-gray-900 dark:text-white">{component.type}</span>
                                {component.format && (
                                  <span className="ml-2 px-2 py-1 bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200 rounded text-xs">
                                    {component.format}
                                  </span>
                                )}
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              {component.type === "HEADER" && component.format && (
                                <div className="flex items-center space-x-2">
                                  {getMediaIcon(component)}
                                  <span className="text-sm text-gray-600 dark:text-gray-400">{component.format}</span>
                                </div>
                              )}
                            </td>
                            <td className="px-6 py-4">
                              {component.text && (
                                <div className="text-sm text-gray-700 dark:text-gray-300 max-w-xs break-words">
                                  {component.text}
                                </div>
                              )}
                            </td>
                            <td className="px-6 py-4">
                              {component.buttons && component.buttons.length > 0 && (
                                <div className="space-y-1">
                                  {component.buttons.map((button, btnIndex) => (
                                    <div key={btnIndex} className="flex items-center space-x-2">
                                      {button.type === "PHONE_NUMBER" && <span className="text-sm">📞</span>}
                                      {button.type === "URL" && <span className="text-sm">🔗</span>}
                                      {button.type === "QUICK_REPLY" && <span className="text-sm">💬</span>}
                                      <span className="text-sm text-gray-600 dark:text-gray-400">
                                        {button.text} ({button.type})
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-gray-600 dark:text-gray-400">No components available</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Templates
